'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Item2.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/views/Item/index.js
// module id = 832
// module chunks = 0